<template>
  <div>
    <v-card v-if="(content.iresa_confiance !== null)" outlined tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">Confiance</div>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showCard">
          <div v-if="loading">
            <v-progress-linear indeterminate color="primary" />
            <v-skeleton-loader class="mb-4" type="list-item" />
          </div>
          <div v-else>
            <v-card-text class="grey lighten-4">
              <div class="col-12 d-flex pa-0">
                <v-switch
                  v-model="confiance"
                  class="mt-0 col-6 pa-0"
                  color="success"
                  hide-details
                  :disabled="disabled"
                >
                  <template #label>
                    <span :class="textColor">Oui Confiance avec impact sur la réservation</span>
                  </template>
                  <template #prepend>
                    <v-label :class="textColor">Non</v-label>
                  </template>
                </v-switch>
                <div v-if="content.iresa_confiance_last_update_date" class="col-6 pa-0 d-flex justify-end">
                  Date de la dernière mise à jour: {{ content.iresa_confiance_last_update_date }}
                </div>
              </div>
            </v-card-text>
            <v-divider />
            <v-card-text v-if="!content.iresa_confiance != !confiance" class="d-flex justify-end">
              <v-btn :disabled="loading" color="secondary" elevation="0" class="mx-2 px-4" @click="saveConfiance(confiance)">
                <v-icon class="mr-3">mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'ConfianceCard',
  components: { },
  props: {
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false,
      showCard: true,
      confiance: this.content.iresa_confiance,
      textColor: this.contentAlteredValues && this.contentAlteredValues.iresa_confiance ? 'green--text' : ''
    };
  },
  computed: {},
  methods: {
    async saveConfiance (event) {
      this.loading = true;
      const editableContent = { ...this.content };
      editableContent.iresa_confiance = event;
      await this.saveCustomer(editableContent);

      // Update newsletters value
      this.newsletters = { ...this.content.newsletters };

      this.loading = false;
    }
  }
};

</script>
<style>
</style>
